export const REQUEST_ORG_SELECTED_TEAM_CHANGE = 'REQUEST_ORG_SELECTED_TEAM_CHANGE';
export const REQUEST_ORG_SELECTED_TEAM_CHANGE__TEAM_UPDATE =
  'REQUEST_ORG_SELECTED_TEAM_CHANGE__TEAM_UPDATE';

export const REQUEST_ORG_SELECTED_TEAM_CHILDREN = 'REQUEST_ORG_SELECTED_TEAM_CHILDREN';
export const REQUEST_ORG_SELECTED_TEAM_CHILDREN_SUCCESS =
  'REQUEST_ORG_SELECTED_TEAM_CHILDREN_SUCCESS';
export const REQUEST_ORG_SELECTED_TEAM_CHILDREN_FAIL = 'REQUEST_ORG_SELECTED_TEAM_CHILDREN_FAIL';
